import styled from 'styled-components'
import { Button } from 'reactstrap'

export const CancelButton = styled(Button)`
  font-size: 18px;
  font-family: Molde-Medium;
  color: #5f5f5f;
  margin: 12px 0px auto;
`

export const SubmitButton = styled(Button)`
  margin: 12px 4px 24px 48px;
  width: 130px;
  height: 42px;
  font-size: 18px;
  font-family: Molde-Medium;
`
